import { z } from "zod";

export const emailConnectionSchema = z.object({
  name: z.string().min(1, "Nama wajib diisi"),
  fromAddress: z.string().email("Alamat email tidak valid"),
  smtpHost: z.string().min(1, "Host wajib diisi"),
  smtpPort: z.string().min(1, "Port wajib diisi"),
  smtpUsername: z.string().min(1, "Username wajib diisi"),
  smtpPassword: z.string().optional(),
  smtpSecure: z.boolean().optional(),
});

export type EmailConnectionFormValues = z.infer<typeof emailConnectionSchema>;

export const defaultEmailConnectionValues: EmailConnectionFormValues = {
  name: "",
  fromAddress: "",
  smtpHost: "",
  smtpPort: "587",
  smtpUsername: "",
  smtpPassword: "",
  smtpSecure: false,
};
